import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/homepage';
export function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <section id="faq" aria-labelledby="faq-heading" className="bg-navy pb-24 pt-12 text-paper md:pb-32" data-id="element-34" data-mp="1orukrj8arzrt">
      <div className="mx-auto max-w-4xl px-6 md:px-10" data-id="element-35" data-mp="1ezowajh980hd">
        <Reveal data-id="element-36" data-mp="1eyx1vbze88so">
          <h2 id="faq-heading" className="font-serif text-4xl font-semibold leading-tight md:text-5xl" data-id="element-37" data-mp="1eydpeasiicm1">
            Common questions
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-38" data-mp="15zjy8zxyaefv" />
        </Reveal>

        <Reveal className="mt-12 border-t border-paper/15" data-id="element-39" data-mp="10znun1t60p0u">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <div key={faq.question} className="border-b border-paper/15" data-id="element-40" data-mp="3lx1tdnkgrtkx" data-mpi={i}>
                <h3 data-id="element-41" data-mp="3qq38nwol1v51">
                  <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left text-xl font-medium transition-colors duration-150 ease-out hover:text-gold md:text-2xl" data-id="element-42" data-mp="3qqcr8z7at00p">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`h-6 w-6 shrink-0 text-gold transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} data-id="element-43" data-mp="3vncyhdfvw8te" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-44" data-mp="2p8ltoynn43u3">
                  {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-45" data-mp="255pwgu0xqrtz">
                      <p className="max-w-3xl pb-8 text-lg leading-relaxed text-paper/85" data-id="element-46" data-mp="1hg3vq24x04jv">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </Reveal>

        <a href="/faq" className="mt-10 inline-flex min-h-[48px] items-center gap-2 text-lg font-semibold text-gold underline-offset-[6px] hover:underline" data-id="element-47" data-mp="18hs17p0xgmm5">
          See all FAQs
          <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-48" data-mp="32rvivttgms4z" />
        </a>
      </div>
    </section>;
}